import React, { useEffect, useState } from 'react';
import { Media } from 'react-bootstrap';
import { Link, withRouter } from "react-router-dom";
import { callAPI } from "../../helper/apiUtils";
import { requestDirectMessage } from "../../helper/directMessagePrompt";
import { BASE_URL } from "../../helper/constants";
import { $user } from "../../helper/UserFactory";
import useTranslation from '../../hooks/useTranslation';
import { convertBranchRole } from '../../helper/convertor';
import UserAvatar from '../../components/UserAvatar';

function ArticleLike(props) {
  const { t, isGerm } = useTranslation();
  const [users, setUsers] = useState([])
  const [article, setArticle] = useState({})
  const user = $user.get()

  const getUsers = async () => {
    const id = props.match.params.id
    const { data } = await callAPI(`/article/${id}/listOfLikes`, {}, 'GET')
    setUsers(data.users)
  }

  const articleDetails = async () => {
    const id = props.match.params.id
    const { data } = await callAPI(`/article/${id}`, {}, 'GET')
    setArticle(data.article[0])
  }

  useEffect(() => {
    getUsers();
    articleDetails();
  }, [])

  const getUserDetails = (person) => {
    const id = person?.id || person;
    if (!id) return;
    requestDirectMessage({
      id,
      fullName: person?.fullName || `${person?.firstName || ""} ${person?.lastName || ""}`.trim(),
      avatar: person?.avatar,
    });
  }
  
  const getAvatarUrl = (user) => {
    // Check multiple possible avatar field names
    const avatar = user?.avatar || user?.userAvatar || user?.userImage || user?.userProfileImage || user?.postedByImage || user?.profileImage;
    
    if (!avatar) return null;
    
    // Check if avatar is already a full URL
    if (typeof avatar === 'string' && (avatar.startsWith('http://') || avatar.startsWith('https://'))) {
      return avatar;
    }
    
    // Check if avatar already contains /getFile (might be partial URL)
    if (typeof avatar === 'string' && avatar.includes('/getFile?filePath=')) {
      // If it's already a complete URL, return as is
      if (avatar.startsWith('http://') || avatar.startsWith('https://')) {
        return avatar;
      }
      // Extract the filePath and reconstruct with BASE_URL
      const filePathMatch = avatar.match(/filePath=(.+)/);
      if (filePathMatch) {
        return BASE_URL + decodeURIComponent(filePathMatch[1]);
      }
      return avatar;
    }
    
    // Otherwise, prepend BASE_URL
    return BASE_URL + avatar;
  };

  return (
    <div className="article-like-wrapper">
      <div className="following article_like article-like-container">
        <div className="main_heading">
          <Link to="/articles">
            <span className="material-symbols-outlined material-arrow-left">
              keyboard_arrow_left
            </span>
          </Link>
          {article.postedById === user?.id
            ? t('people_who_like_article')
            : t('people_that_like_article')}
        </div>
        <div className="article-like-list">
          {users?.map((likeUser) => (
            <div key={likeUser?.id} className="post_notification">
              <div className="my_post">
                <Media>
                  <UserAvatar
                    width={40}
                    height={40}
                    className="mr-3"
                    src={getAvatarUrl(likeUser)}
                    alt="Generic placeholder"
                    fallbackSrc={process.env.PUBLIC_URL + "/assets/img/head.svg"}
                    isKjuup={likeUser.isKjuup || likeUser.companies?.some(c => c.isKjuup)}
                  />
                  <Media.Body>
                    <div className="authore_name">
                      <h5
                        className="pointer"
                        onClick={() => getUserDetails(likeUser)}
                      >
                        {likeUser?.fullName}
                      </h5>
                      <p className='simple-msg'>
                        {convertBranchRole(likeUser?.buildingIndustryRole, isGerm, false, true)}
                      </p>
                    </div>
                  </Media.Body>
                </Media>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default withRouter(ArticleLike);
